<template>
  <div>
    <hardware-info v-if="showInfo" @close="showInfo = false"></hardware-info>
    <my-header
      :page_name="$t('navigation.headerTitles.servers')"
      show_usermenu
    ></my-header>
    <el-dialog
      :title="$t('servers.versions')"
      :visible.sync="versionsDialogVisible"
      center
    >
      <div>
        <div>
          {{ $t("servers.mainAgentVersion") }} &mdash;
          {{ serversVersions.main }}
        </div>
        <div>{{ serversVersions.front }}</div>
        <br />
        <div>{{ $t("servers.tinyAgentsVersions") + ":" }}</div>
        <ul>
          <li
            v-for="(server, index) in serversVersions.tiny"
            :key="index"
            class="tiny-version"
          >
            {{ server.name }} &mdash; {{ server.vers }}<br /><span
              v-if="server.unix"
              >{{ server.unix }}</span
            ><span v-else>UNKNOWN</span>
          </li>
        </ul>
      </div>
    </el-dialog>
    <el-button
      @click="getServersVersions"
      class="versions-button"
      size="mini"
      >{{ $t("servers.versions") }}</el-button
    >
    <el-button
      @click="showInfo = true"
      class="info-button"
      size="mini"
      >{{ $t("servers.hardwareInfo") }}</el-button
    >
    <reference-grid
      :gridData="getServersTableArray"
      :columns="columnDefs"
      gridType="server"
      @deleteClicked="deleteClick"
    ></reference-grid>
  </div>
</template>

<script>
import Header from "../../components/reusable/header/Header";
import ReferenceGrid from "../../components/reference/ReferenceGrid";
import HardwareInfo from "../../components/reference/HardwareInfo";
import { mapGetters } from "vuex";
import { getVers } from "../../helpers/helper_store";
import i18n from "@/locales";
export default {
  data() {
    return {
      columnDefs: [],
      versionsDialogVisible: false,
      showInfo: false
    };
  },
  methods: {
    deleteClick({ currentId, title }) {
      this.$confirm(
        `${this.$t("servers.mainAgentVersion")}: ${title}. ${this.$t(
          "servers.continue"
        )}?`,
        this.$t("servers.attention"),
        {
          confirmButtonText: "OK",
          cancelButtonText: this.$t("servers.cancellation"),
          type: "warning",
        }
      )
        .then(() => {
          this.$store.commit("setLoading", true);
          return this.$store.dispatch("delServerTable", currentId);
        })
        .then(() => {
          return this.$store.dispatch("getServerTable");
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    getServersVersions() {
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("getServersVersions")
        .then(() => {
          this.$store.commit("setLoading", false);
          this.versionsDialogVisible = true;
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
  },
  created() {
    this.$store.commit("setLoading", true);
    this.columnDefs = [
      { headerName: i18n.t("tableHeaders.server.name"), field: "serverName" },
      {
        headerName: i18n.t("tableHeaders.server.serverType"),
        field: "serverTypeSrvName",
      },
      {
        headerName: i18n.t("tableHeaders.server.httpPath"),
        field: "serverURL",
      },
      { headerName: i18n.t("tableHeaders.server.host"), field: "serverHost" },
      { headerName: i18n.t("tableHeaders.server.path"), field: "serverPath" },
      { headerName: i18n.t("tableHeaders.server.isTiny"), field: "tiny" },
    ];
    this.$store.dispatch("getServerTable").catch(() => {
      this.$store.commit("setLoading", false);
    });
  },
  computed: {
    ...mapGetters(["getServersTableArray", "serversVersions"]),
  },
  components: {
    myHeader: Header,
    ReferenceGrid,
    HardwareInfo
  },
};
</script>

<style scoped>
.versions-button {
  position: absolute;
  right: 5px;
  margin-top: 10px;
}
.info-button {
  position: absolute;
  right: 100px;
  margin-top: 10px;
}
.tiny-version {
  margin-left: 30px;
  list-style: disc;
}
</style>